var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-content"},[_c('canvas',{attrs:{"id":_vm.tag}})])
}
var staticRenderFns = []

export { render, staticRenderFns }